import React, { useEffect } from "react";
import { Typography } from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";

const SelectedScoreData = ({ data }) => {

  useEffect(() => {
    const yOffset = -document.getElementsByClassName('main-header')[0].offsetHeight;
    const element = document.getElementById('selectedScoreData');
    const posi = element.getBoundingClientRect().top + window.scrollY + yOffset;

    window.scrollTo({ top: posi, behavior: 'smooth' });
  }, [])

  return (
    <div style={{ margin: 20 }} id="selectedScoreData">
      <Typography className="whiteText" align="center" style={{ fontSize: 28 }}>
        {`${getLocalizedString("evaluatedGroupSelectedWithScore")}: ${data.name}`}
      </Typography>
      <Typography className="whiteText" align="center" style={{ fontSize: 20 }}>
        {`${getLocalizedString("amountOfCollaboratorsWithThisScore")}: ${data.value}`}
      </Typography>
    </div>
  );
}

export default SelectedScoreData;